import React from 'react';
import CenteredImageContainer from "../CenteredImageContainer";
import {getResourceImageUrl} from "../../actions/networkActions";

function CartElementImage(props) {
    return (
        <div className="w-full sm:w-1/2 md:w-2/5 xl:w-1/3 sm:hidden xl:block">
            <CenteredImageContainer
                alt={props.name}
                src={getResourceImageUrl(props.imageReference, {width: 400, category:props.imageCategory})}
            />
        </div>
    );
}

export default CartElementImage;